import React from 'react';
import { Button, Tooltip, Modal, notification } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { Document} from "../../../types";
import {useAppDispatch} from "../../../redux/hooks";
import {deleteDocument} from "../../../redux/api/documents/documentsThunks";

export interface DocumentDeleteActionProps {
    document: Document;
}

const DocumentDeleteAction: React.FC<DocumentDeleteActionProps> = ({ document }) => {
    const dispatch = useAppDispatch();

    const handleDelete = () => {
        Modal.confirm({
            title: 'Вы уверены, что хотите удалить этот документ?',
            cancelText: 'Нет',
            okText: 'Удалить',
            onOk: async () => {
                try {
                    const action = await dispatch(deleteDocument(document.id));
                    if (deleteDocument.fulfilled.match(action)) {
                        notification.success({ message: 'Документ удален' });
                    } else {
                        notification.error({
                            message: 'Ошибка при удалении документа',
                            description: action.payload || 'Не удалось удалить документ.',
                        });
                    }
                } catch (error: any) {
                    notification.error({
                        message: 'Ошибка при удалении документа',
                        description: error.message || 'Не удалось удалить документ.',
                    });
                }
            },
        });
    };

    return (
        <Tooltip title="Удалить">
            <Button shape="circle" icon={<DeleteOutlined />} onClick={handleDelete} danger />
        </Tooltip>
    );
};

export default DocumentDeleteAction;
